export default function (price, noValue = '-') {
  if (!price ||
    price.amount === undefined ||
    price.amount === null ||
    isNaN(price.amount) ||
    !(price.amount || price.allowZero)) {
    return noValue
  }
  let prefix = price.currency

  switch (price.currency) {
  case 'USD':
    prefix = 'US$'
    break
  case 'AUD':
    prefix = 'A$'
    break
  case 'CAD':
    prefix = 'CA$'
    break
  case 'NZD':
    prefix = 'NZ$'
    break
  case 'ZAR':
    prefix = 'R'
    break
  case 'EUR':
    prefix = '€'
    break
  case 'GBP':
    prefix = '£'
    break
  }

  return `${prefix} ${price.amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`
}
